import React from 'react'
import { Link } from 'react-router-dom'
import { down } from 'styled-breakpoints'
import { useBreakpoint } from 'styled-breakpoints/react-styled'
import styled from 'styled-components'
import { TABLET } from '../../lib/constant'
import Accordion from '../common/Accordion'

const faqData = [
	{
		id: 1,
		summary: '환불 방법이 궁금해요!',
		details:
			'환불완료 까지는 통상 2~3일 정도 소요되며 자세한 사항은고객센터를 통해 연락주시면 도움드리도록 하겠습니다.\n신고하기: 사유에 맞는 항목을 선택하여 기기 및 고객정보를 상세히 작성해주세요.\n전화상담: 1811-6081',
	},
	{
		id: 2,
		summary: '서비스 이용요금결제방법(수단)이 궁금해요!',
		details:
			'[결제 및 인증]에서 최초 1회만 카드 정보를 등록하면, 운행 종료 후 등록된 카드로 자동 결제됩니다.\n여러 카드를 등록할 수 있으며 그 중 자동결제될 대표 카드를 선택할 수 있습니다.',
	},
	{
		id: 3,
		summary: '주차금지구역이 궁금해요!',
		details:
			'서비스지역 내에도 스쿨존, 위험지역 등과 같은 주차금지구역이 있습니다. 주차 금지지역(앱 지도상 진한 자주색 영역)에서는 주차 시 주차벌금(500원)이 부과 됩니다.\n또한 개인사유지, 자동차 및 장애인 전용 주차장, 상가 앞, 공공기관 앞 등에서는 주차를 자제해 주세요.(패널티가 발생할 수 있습니다.)',
	},
	{
		id: 4,
		summary: '서비스 지역은 어디인가요?',
		details:
			'정상 서비스 지역은 타고가 앱에서 보실 때 지도 배경 지역의 안쪽에 있는 밝은 부분입니다.\n서비스 지역 안 붉은색 어두운 부분은(진한 자주색) 주차 벌금 구역이며, 밝은 부분을 제외한 어두운 부분은 반납 금지 지역이며, 반납 금지 지역에서 반납하시면 회수비용(5,000원)이 부과됩니다.',
	},
	{
		id: 5,
		summary: '고객센터 운영 시간이 궁금해요!',
		details:
			'고객센터(1811-6081) 운영시간은 평일 09:00~17:00 까지만 운영하고 있으며, 운영 시간 외에는 타고가 앱의 [신고하기] 기능을 이용하여 남겨주시면 운영 시간 중 확인하여 처리하도록 하겠습니다.',
	},
]

export default function MainFAQSection() {
	const isTablet = useBreakpoint(down(TABLET))
	return (
		<Section>
			<Left>
				<h3>
					자주하는 <br /> 질문
				</h3>
				{!isTablet && <Button to="/faq">더보기</Button>}
			</Left>
			<AccordionWrapper>
				{faqData.map(({ id, summary, details }) => (
					<Accordion key={id} summary={summary} details={details} />
				))}
			</AccordionWrapper>
			{isTablet && <Button to="/faq">더보기</Button>}
		</Section>
	)
}

const Section = styled.section`
	display: flex;
	justify-content: space-between;
	max-width: 1112px;
	margin: 0 auto;
	padding: 0 16px;
	margin-top: 196px;

	${down(TABLET)} {
		flex-direction: column;
		width: 100%;
		br {
			display: none;
		}
	}
`

const Left = styled.div`
	& > h3 {
		font-size: 64px;
		line-height: 68px;
		font-weight: 700;

		${down(TABLET)} {
			font-size: 32px;
			line-height: 40px;
			margin-bottom: 16px;
		}
	}
`

const AccordionWrapper = styled.div`
	width: 680px;

	${down(TABLET)} {
		width: 100%;
	}
`

export const Button = styled(Link)`
	display: inline-flex;
	justify-content: center;
	align-items: center;
	appearance: none;
	border: 2px solid black;
	border-radius: 85px;
	background-color: white;
	margin-top: 24px;
	padding: 10px 16px;
	font-size: 24px;
	line-height: 28px;
	font-weight: 500;
	cursor: pointer;
	width: max-content;

	&:hover {
		opacity: 0.7;
	}

	${down(TABLET)} {
		font-size: 16px;
		line-height: 24px;
		margin-top: 16px;
		order: 3;
	}
`
